import { render, staticRenderFns } from "./MailboxPolygons.vue?vue&type=template&id=4e6b4483&"
import script from "./MailboxPolygons.vue?vue&type=script&lang=js&"
export * from "./MailboxPolygons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports